import React from 'react';
import { dispatch } from '@rematch/core';
import { connect } from 'react-redux';
import { Header } from 'semantic-ui-react';
import { Dropdown, Checkbox } from 'semantic-ui-react'
import LoadingComponent from "./../common/LoadingComponent";
// import PageHeader from "./PageHeader";
import PricingTable from './PricingTable'
import './styles.css';


const options = [
    { key: 1, text: 'US', value: "usd" },
    { key: 2, text: 'INDIA', value: "inr" },
    { key: 3, text: 'EURO', value: "eur" },
    { key: 4, text: 'UK', value: "gbp" },
]

let server_url = process.env.REACT_APP_SERVER_URL;

if (!server_url || server_url === "") {
    server_url = `${window.location.protocol}//${window.location.hostname}`;
    if (window.location.port !== "") {
        server_url = `${server_url}:${window.location.port}`;
    }
}

class PricingPage extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            plans: null,
            currencyCode: "usd",
            periodUnit: "month"
        };
    }

    toggle = (e, data) => {
        this.setState((prevState) => ({ periodUnit: data.checked ? "year" : "month" }))
        this.setState({ plans: null })
        this.getPlanData(this.state.currencyCode, data.checked ? "year" : "month");
    }

    getPlanData = (currencyCode, periodUnit) => {
        const requestUrl = `${server_url}/plans?currencyCode=${currencyCode}&&periodUnit=${periodUnit}&&usageType=licensed`;
        fetch(requestUrl)
            .then(response => response.json())
            .then(plans => this.setState({ plans }));
    }

    changeSelection = (e, data) => {
        e.stopPropagation();
        this.setState({ currencyCode: data.value });
        this.setState({ plans: null })
        this.getPlanData(data.value, this.state.periodUnit);
    }

    componentWillMount() {
        this.getPlanData(this.state.currencyCode, this.state.periodUnit);
        dispatch.app.getShowPricingTableEnv();
    }

    render() {
        let component = null;
        let plans = this.state.plans;

        if (this.props.isProd === 'true') {
            this.props.history.push('/login');
        } else {
            if (plans !== null) {
                component = <PricingTable plans={plans} currencyCode={this.state.currencyCode} periodUnit={this.state.periodUnit} />;
            } else {
                component = <LoadingComponent active={true} message="Loading Subscription Plans..." />;
            }
        }

        return (
            <div>
                {/* <PageHeader history={this.props.history} />  */}

                <Header as='h2' icon textAlign='center'>
                    <Header.Content>Pricing Table</Header.Content>
                </Header>
                {/* <Header as='h4' textAlign='center'>
                    <Dropdown placeholder='Country'
                        defaultValue={this.state.currencyCode}
                        selection
                        onChange={this.changeSelection}
                        options={options} />


                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        Monthly &nbsp;&nbsp;&nbsp; <Checkbox
                        slider label="&nbsp;" 
                        onChange={this.toggle}
                        checked={this.state.annual} />
                        Yearly

                </Header>
                {component} */}
                <stripe-pricing-table pricing-table-id={process.env.REACT_APP_STRIPE_PRICING_TABLE_KEY}
                    publishable-key={process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY}>
                </stripe-pricing-table>
            </div>
        );
    }
}

function mapStateToProps(state) {
    const { isProd } = state.app;
    return {
        isProd
    };
}

const connectedPricingPage = connect(mapStateToProps)(PricingPage);
export { connectedPricingPage as PricingPage };